import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from '@/interfaces';
import { NotificationsList, PendingNotifications } from '@/interfaces';

class NotificationsService {
	constructor(private client: AxiosInstance) {}

	async getPending(): Promise<HttpResponse<PendingNotifications>> {
		return this.client.get('/notifications/me/pendings');
	}

	async getNotifications(
		page: number,
		limit: number
	): Promise<HttpResponse<NotificationsList>> {
		return this.client.get(`/notifications/me?page=${page}&limit=${limit}`);
	}

	async patchMarkUnread(
		notificationId: string
	): Promise<HttpResponse<PendingNotifications>> {
		return this.client.patch(`/notifications/${notificationId}/mark-as-unread`);
	}

	async patchMarkRead(
		notificationId: string
	): Promise<HttpResponse<PendingNotifications>> {
		return this.client.patch(`/notifications/${notificationId}/mark-as-read`);
	}

	async deleteNotification(
		notificationId: string
	): Promise<HttpResponse<PendingNotifications>> {
		return this.client.delete(`/notifications/${notificationId}`);
	}
}

export const notificationsService = new NotificationsService(axiosClient);
